import i18n from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../../locales/en.json";
import ru from "../../locales/ru.json";
import am from "../../locales/am.json";

const domain = process.env.REACT_APP_COOKIE_DOMAIN;
const supportedLanguages = ["en", "ru", "am"];

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    load: "languageOnly",
    debug: false,
    detection: {
      order: ["querystring", "localStorage", "cookie", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage", "cookie"],
      cookieDomain: domain,
    },
    resources: {
      en,
      ru,
      am,
    },
    // keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.setAttribute("lang", lng);
});

if (typeof window !== "undefined") {
  const url = new URL(window.location.href);
  const queryLang = url.searchParams.get("lang");

  if (queryLang && supportedLanguages.includes(queryLang)) {
    i18n.changeLanguage(queryLang);

    // Consume language from URL once, so manual language changes
    // are not overwritten by the same query value on refresh.
    url.searchParams.delete("lang");
    window.history.replaceState({}, "", url.toString());
  }
}

export default i18n;
